module.exports = __webpack_public_path__ + "Flag-400.720d35a45343901bc51f2b4f2fba7659.svg";